import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import "./login.css"
import Logo from "../assets/images/Logo.png"
import { axiosInstance } from '../config/https'
import { toast } from "react-toastify";
import { Loader } from "react-overlay-loader"

export default function Confirmpassword() {
  const navigate = useNavigate()
  const location = useLocation();
  const [newpassword, setNewpassword] = useState("");
  const [confirmpass, setConfirmpass] = useState("");
  const [loader, setLoader] = useState(false);

  const ForgetPassword = () => {
    setLoader(true)

    if (newpassword === confirmpass) {

      //  fromdata data passing 
      const formData = new FormData()
      formData.append("password", confirmpass)
      formData.append("userid", location.state.userId)

      axiosInstance.post("/user/forgetConfirmation", formData)
        .then((response) => {
          setLoader(false)
          if (response?.data?.status) {
            console.log("response.data", response.data)
            toast.success(response.data.message)
            navigate("/Login")

          }else {
            toast.warning(response?.data?.message)
          }
        }).catch(() => {
          setLoader(false)

        })
    } else {
      setLoader(false)
      toast.error("Password Not Match")
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    ForgetPassword();
  };
  return (
    <>
      {loader === true ? <Loader fullPage loading /> : null}

      <section className=' d-flex align-items-center' style={{ height: "100vh" }}>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-6'>
              <div className='login'>

                <div className="head">
                  <img src={Logo} alt='' />

                </div>
                <p className="msg mt-4 para">Set Your New Password.</p>
                <div className="form">
                  <form onSubmit={handleSubmit}>


                    <input
                      type="password"
                      placeholder="Enter New Password"
                      className="password"
                      value={newpassword}
                      onChange={(e) => setNewpassword(e.target.value)}
                    />

                    <br />

                    <input
                      type="password"
                      placeholder="Enter Confirm Password"
                      className="password"
                      value={confirmpass}
                      onChange={(e) => setConfirmpass(e.target.value)}
                    />

                    <br />
                    <div className='row'>
                      <div className='col-md-12 mt-2 text-center'>
                        <button
                          className="btn-login rounded-pill" type='button' onClick={() => ForgetPassword()} >
                          Submit
                        </button>

                      </div>
                    </div>

                  </form>

                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

    </>
  )
}
